import { css } from 'aphrodite';
import { s } from './styles';

export function Skeleton({ styles = [], ...props }: AphroditeStyled<React.ComponentProps<'div'>>) {
	return <div data-slot='skeleton' className={css(s.root, ...styles)} {...props} />;
}
